exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help .unit-header{min-height:0}.help__back-button{height:100px;width:100px;position:absolute;top:26px;margin-left:860px;fill:#fff;cursor:pointer}.help__back-button-disabled{opacity:.3;pointer-events:none;cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/modules/help/help.scss
// module id = 609
// module chunks = 0